/**
 * © [2024] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as actionTypes from './ActionTypes';

const axiosPayLoad = {
  errorMessagesInRedux: [],
  systemReminderList: [],
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.HANDLE_ERROR_MESSAGE_SR:
      return {
        ...state,
        errorMessagesInRedux: action.errorMessagesInRedux,
      };

    case actionTypes.GET_SYSTEM_REMINDER_LIST:
      return { ...state, systemReminderList: action.systemReminderList };

    default:
      return state;
  }
};

export default reducer;
